import { render, staticRenderFns } from "./BinComponent.vue?vue&type=template&id=bf8e4c26&scoped=true"
import script from "./BinComponent.vue?vue&type=script&lang=js"
export * from "./BinComponent.vue?vue&type=script&lang=js"
import style0 from "./BinComponent.vue?vue&type=style&index=0&id=bf8e4c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8e4c26",
  null
  
)

export default component.exports